import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Lock, Shield, CheckCircle, AlertCircle } from "lucide-react";

const PERMISSION_OPTIONS = [
  { id: "manage_students", label: "Manage Students", description: "Add, edit, remove students" },
  { id: "bulk_upload", label: "Bulk Upload", description: "Upload students via CSV" },
  { id: "manage_teachers", label: "Manage Teachers", description: "Add, edit, remove teachers" },
  { id: "view_billing", label: "View Billing", description: "View invoices and billing summary" },
  { id: "manage_billing", label: "Manage Billing", description: "Start/modify subscriptions" },
  { id: "view_analytics", label: "View Analytics", description: "View performance analytics" },
  { id: "export_data", label: "Export Data", description: "Export reports and data" },
  { id: "manage_admins", label: "Manage Admins", description: "Add, edit other admins" },
];

export function SecurityTab({
  permissions,
  onChangePassword
}) {
  return (
    <div className="space-y-6">
      <Card className="border-0 shadow-sm">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Lock className="w-5 h-5 text-emerald-600" />
            Password
          </CardTitle>
          <CardDescription>Update your account password</CardDescription>
        </CardHeader>
        <CardContent>
          <Button 
            variant="outline" 
            onClick={onChangePassword}
            data-testid="change-password-btn"
          >
            <Lock className="w-4 h-4 mr-2" />
            Change Password
          </Button>
        </CardContent>
      </Card>

      <Card className="border-0 shadow-sm">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Shield className="w-5 h-5 text-emerald-600" />
            Your Permissions
          </CardTitle>
          <CardDescription>What you can do in this portal</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {PERMISSION_OPTIONS.map(perm => (
              <div 
                key={perm.id} 
                className={`p-4 rounded-lg border ${
                  permissions.includes(perm.id) 
                    ? "border-emerald-200 bg-emerald-50" 
                    : "border-slate-200 bg-slate-50 opacity-50"
                }`}
              >
                <div className="flex items-center gap-2">
                  {permissions.includes(perm.id) ? (
                    <CheckCircle className="w-4 h-4 text-emerald-600" />
                  ) : (
                    <AlertCircle className="w-4 h-4 text-slate-400" />
                  )}
                  <span className="font-medium text-slate-800">{perm.label}</span>
                </div>
                <p className="text-xs text-slate-500 mt-1 ml-6">{perm.description}</p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
